import { useStrings } from "@1js/localization-components";
import {
  Menu,
  MenuDivider,
  MenuItem,
  MenuItemCheckbox,
  MenuList,
  MenuPopover,
  MenuTrigger,
  type MenuProps,
} from "@fluentui/react-components";
import * as React from "react";
import { ResetFilterLabel } from "../../sharedStrings";
import {
  CLEAR_FILTER_TOKEN,
  FILTER_CONCATENATE_TOKEN,
  type FilterOption,
} from "../types";
import { usePromptFilterLocalizations } from "../usePromptFilterStrings";
export type SubMenuFilterProps = {
  filterOptions: FilterOption[];
  triggerDisplayLabel: string;
  groupDisplayLabel: string;
  selectedValues: string[] | undefined;
  onChangeChecked: MenuProps["onCheckedValueChange"];
  checkedValues: Record<string, string[]>;
  isDisabled?: boolean;
};

export const SubMenuFilter: React.FC<SubMenuFilterProps> = ({
  filterOptions,
  groupDisplayLabel,
  triggerDisplayLabel,
  selectedValues,
  onChangeChecked,
  checkedValues,
  isDisabled,
}) => {
  const { facetValueToLabel, groupValueToLabel } =
    usePromptFilterLocalizations();

  const localizations = useStrings({
    ResetFilterLabel,
  });

  const selectAllChecked =
    Object.keys(selectedValues || {}).length < 1
      ? {
          [`${CLEAR_FILTER_TOKEN}${FILTER_CONCATENATE_TOKEN}${groupDisplayLabel}${FILTER_CONCATENATE_TOKEN}${triggerDisplayLabel}`]:
            [
              `${CLEAR_FILTER_TOKEN}${FILTER_CONCATENATE_TOKEN}${groupDisplayLabel}${FILTER_CONCATENATE_TOKEN}${triggerDisplayLabel}`,
            ],
        }
      : {};

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <MenuItem
          data-testid={`${triggerDisplayLabel}-submenu`}
          disabled={isDisabled}
        >
          {groupValueToLabel(triggerDisplayLabel)}
        </MenuItem>
      </MenuTrigger>
      <MenuPopover>
        <MenuList
          onCheckedValueChange={onChangeChecked}
          checkedValues={{ ...checkedValues, ...selectAllChecked }}
        >
          <MenuItemCheckbox
            name={`${CLEAR_FILTER_TOKEN}${FILTER_CONCATENATE_TOKEN}${groupDisplayLabel}${FILTER_CONCATENATE_TOKEN}${triggerDisplayLabel}`}
            value={`${CLEAR_FILTER_TOKEN}${FILTER_CONCATENATE_TOKEN}${groupDisplayLabel}${FILTER_CONCATENATE_TOKEN}${triggerDisplayLabel}`}
            key={CLEAR_FILTER_TOKEN}
            aria-label={`selectall-menuitemcheckbox`}
            aria-checked={selectedValues?.includes(
              `${CLEAR_FILTER_TOKEN}${FILTER_CONCATENATE_TOKEN}${groupDisplayLabel}${FILTER_CONCATENATE_TOKEN}${triggerDisplayLabel}`
            )}
            secondaryContent={localizations.ResetFilterLabel()}
          >
            {facetValueToLabel(CLEAR_FILTER_TOKEN)}
          </MenuItemCheckbox>
          <MenuDivider />
          {filterOptions.map((filterOption) => {
            return (
              <MenuItemCheckbox
                name={
                  filterOption.displayLabel ||
                  facetValueToLabel(filterOption.value)
                }
                value={`${filterOption.value}${FILTER_CONCATENATE_TOKEN}${groupDisplayLabel}${FILTER_CONCATENATE_TOKEN}${triggerDisplayLabel}`}
                key={filterOption.value}
                aria-label={`${filterOption.displayLabel || facetValueToLabel(filterOption.value)}-menuitemcheckbox`}
                aria-checked={selectedValues?.includes(filterOption.value)}
              >
                {filterOption.displayLabel ||
                  facetValueToLabel(filterOption.value)}
              </MenuItemCheckbox>
            );
          })}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
